import React from 'react';

const ReadingProgress: React.FC = () => {
  const [readingProgress, setReadingProgress] = React.useState(0);

  React.useEffect(() => {
    const updateReadingProgress = () => {
      const currentProgress = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight > 0) {
        setReadingProgress((currentProgress / scrollHeight) * 100);
      }
    };

    window.addEventListener('scroll', updateReadingProgress);
    updateReadingProgress();

    return () => window.removeEventListener('scroll', updateReadingProgress);
  }, []);

  return (
    <div 
      className="fixed top-0 left-0 w-full h-1 z-50"
      role="progressbar"
      aria-valuenow={readingProgress}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full bg-gradient-to-r from-cancun-turquoise to-cancun-sunset transition-all duration-200 ease-out"
        style={{ width: `${readingProgress}%` }}
      />
    </div>
  );
};

export default ReadingProgress;